module.exports = __webpack_public_path__ + "img/avatar02.0af85ffe.png";